export enum WithdrawalFormName {
  Amount = "amount",
  Currency = "currency",
}
